import { RTDBPath } from 'balus-common';
import { Channel } from '@framework/notification';
import { HuddleMessage } from './message';
import type { HuddleMessageNotificationJSON, ViewModelId } from 'balus-common';

export class ViewModelNotification {
  constructor(private readonly viewModelId: ViewModelId) {}

  huddleChannel(): Channel<HuddleMessageNotificationJSON['payload'], HuddleMessage> {
    return new Channel(RTDBPath.ViewModelViewer.huddlePath(this.viewModelId), HuddleMessage);
  }
}
